import { default as React } from 'react';
import { DocsIcon, Table } from '@backstage/core-components';
import {
  Card,
  CardHeader,
  Divider,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import { DisasterRecovery, CpeCardProps } from '../types';
import { DisasterRecoveryEditIcon } from './DisasterRecoveryEditIcon';
import { StatusIndicatorTitle } from '../StatusIndicatorTitle';
import { useAccountFeatures } from '../hooks/useAccountFeatures';
import { useStyles } from '../styles';

export function DisasterRecoveryCard(props: CpeCardProps) {
  const classes = useStyles();
  const { variant } = props;
  const features = useAccountFeatures();

  // Local state for disaster recovery configuration
  const [disasterRecovery, setDisasterRecovery] = React.useState(
    features?.disaster_recovery || {
      validation_enabled: false,
      primary_region: '',
      secondary_region: '',
    },
  );

  const handleUpdate = (updatedDisasterRecovery: DisasterRecovery) => {
    setDisasterRecovery(updatedDisasterRecovery);
  };

  const rows = [
    {
      region_type: 'Primary Region',
      region: disasterRecovery?.primary_region || '',
    },
    {
      region_type: 'Secondary Region',
      region: disasterRecovery?.secondary_region || '',
    },
  ];

  const columns = [
    {
      title: 'Region Type',
      width: '30%',
      render: (rowData: any) => {
        return rowData.region_type;
      },
    },
    {
      title: 'Region',
      width: '80%',
      render: (rowData: any) => {
        return rowData.region;
      },
    },
  ];

  let cardClass = '';
  let cardContentClass = '';
  if (variant === 'gridItem') {
    cardClass = classes.gridItemCard;
    cardContentClass = classes.gridItemCardContent;
  } else if (variant === 'fullHeight') {
    cardClass = classes.fullHeightCard;
    cardContentClass = classes.fullHeightCardContent;
  }

  return (
    <Card className={cardClass}>
      <CardHeader
        title="Disaster Recovery"
        titleTypographyProps={{ component: 'h2' }}
        action={
          <CardActions>
            <Tooltip title="Learn more about Disaster Recovery in AWS">
              <IconButton
                href="/docs/principalfinancialgroup-emu/component/principal-engineering-handbook/operations/reliability/disaster-recovery"
                target="_blank"
              >
                <DocsIcon />
              </IconButton>
            </Tooltip>
            <DisasterRecoveryEditIcon
              disasterRecovery={disasterRecovery}
              onUpdate={handleUpdate}
            />
          </CardActions>
        }
      />
      <Divider />
      <CardContent className={cardContentClass}>
        <StatusIndicatorTitle
          enabled={disasterRecovery?.validation_enabled}
          title="Validation"
        />
        <Table
          columns={columns}
          data={rows}
          options={{
            showTitle: false,
            loadingType: 'linear',
            header: false,
            search: false,
            padding: 'dense',
            toolbar: false,
            paging: rows.length > 5,
            pageSizeOptions: [5],
          }}
        />
      </CardContent>
    </Card>
  );
}
